/**
 * Returns the appropriate base URL based on keywords in the current window.location.href.
 *
 * - If "qa" is in the URL, returns the QA base URL.
 * - If "dev" is in the URL, returns the Dev base URL.
 * - If "stg" is in the URL, returns the Staging base URL.
 * - Otherwise, returns the Production base URL by default.
 *
 * Note: Keyword matching is case-insensitive.
 */

const PROD_BASE_URL = 'https://my.dnb.com';
const STG_BASE_URL = 'https://my-stg.dnb.com';
const DEV_BASE_URL = 'https://qa.mydnb.nonprod.gcpdnb.net';
const QA_BASE_URL = 'https://qa.mydnb.nonprod.gcpdnb.net';
const LOCAL_BASE_URL = 'http://localhost:8080';

function getBaseUrl(): string {
    const envChecks = [
        { keyword: 'localhost', url: LOCAL_BASE_URL },
        { keyword: 'dev', url: DEV_BASE_URL },
        { keyword: 'qa', url: QA_BASE_URL },
        { keyword: 'stg', url: STG_BASE_URL },
    ];

    if (typeof window === 'undefined' || !window.location || !window.location.href) {
        console.warn('window.location.href is not available. Falling back to Production URL.');
        return PROD_BASE_URL;
    }
    const currentUrl = window.location.href.toLowerCase();

    for (const envCheck of envChecks) {
        if (currentUrl.includes(envCheck.keyword)) {
            return envCheck.url;
        }
    }

    // Default to production if no specific environment keyword is found
    return PROD_BASE_URL;
}

export default getBaseUrl;